module.exports = __webpack_public_path__ + "img/focaccia.e705edea.svg";